import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { focusOutline } from '@hivebrite/design-system/Theme';

import IconExternalLink from 'hb-react/shared/icons/ExternalLink';

const NoPreviewExternalLink = () => (
  <StyledWrapper>
    <StyledText>
      {s__('Portfolio|There is no available preview for this external link')}
    </StyledText>
    <StyledText mb={8}>
      {s__('Portfolio|Please click below to view it')}
    </StyledText>
    <StyledAction data-testid="anchor-action">
      <IconExternalLink height={80} width={80} />
    </StyledAction>
  </StyledWrapper>
);
export default NoPreviewExternalLink;

const StyledWrapper = styled(Box).attrs({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  height: 'inherit',
  alignItems: 'center',
})``;

const StyledAction = styled(Box)`
  ${focusOutline};
  color: ${(props) => props.theme.colors.primary};

  cursor: pointer;
  user-select: none;
  z-index: 1;

  &:hover,
  &:focus {
    color: ${(props) => props.theme.colors.primaryDark};
  }
`;

const StyledText = styled(Box).attrs({
  display: 'block',
  font: 'body-asphalt-italic',
})``;
